import { ADMIN_STYLES } from "@/lib/admin-styles";

interface AdminPageHeaderProps {
  id?: string;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function AdminPageHeader({ id = "page-heading", title, subtitle, actions }: AdminPageHeaderProps) {
  return (
    <header className={`${ADMIN_STYLES.header.wrapper} flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3`}>
      <div className="min-w-0">
        <h1 id={id} className={ADMIN_STYLES.header.title}>
          {title}
        </h1>
        {subtitle && <p className={ADMIN_STYLES.header.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}
